<template>
  <autocomplete v-model="searchQuery" :static-items="staticItems" :disabled="!staticItems || staticItems.length === 0" :options="options" :on-item-selected="onSearchItemSelected" :on-input-change="onInputChange" :required="required">
    <template #item="props">
      <strong>{{ props.item.external_id }}</strong>
      ({{ props.item.reference }})
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  name: 'CommodityVarietyAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    preQuery: {
      type: String,
      default: ''
    },
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      },
      currentMssgClass: 'left',
      profilePictureSize: '50',
      staticItems: this.commodityVarieties
    }
  },
  watch: {
    preQuery(val) {
      this.searchQuery = val || ''
    },
    commodityVarieties: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        console.log('Updating commodityVarieties', val, oldVal)
        this.staticItems = val
      }
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('Type to search...')
    }
  },
  methods: {
    onInputChange(query) {
      if (this.staticItems.length > 0) {
        if (query.trim().length > 0) {
          return this.staticItems.filter((item) => {
            return item.reference.toLowerCase().includes(query.toLowerCase()) || item.external_id.toLowerCase().includes(query.toLowerCase())
          })
        } else {
          this.$emit('selected', null)
          return this.staticItems
        }
      } else {
        return this.staticItems
      }
    },
    onSearchItemSelected(item) {
      this.searchQuery = item.external_id
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
